import { get, post } from "@/application/api";
import { AxiosResponse } from "axios";

export const exportSalesOrders = (
  clientId: number
): Promise<AxiosResponse<Blob>> =>
  get(`client/${clientId}/sales-order/concept/export`, {
    responseType: "blob",
  });

export const importSalesOrders = (
  clientId: number,
  file: File
): Promise<AxiosResponse<{ data: { failed: number[] } }>> => {
  const formData = new FormData();
  formData.append("file", file);
  return post(`client/${clientId}/sales-order/import`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
